import React from 'react'

export class EmailProvider extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      shallActivateEmailButton: false,
      isFeedbackSent: false
    }
  }

  render() {
    return (
      <EmailContext.Provider
        value={{
          state: this.state,
          activatedEmailButton: () => {
            this.setState({...this.state, shallActivateEmailButton: true})
          },
          isFeedbackAlreadySent: () => {
            this.setState({...this.state, isFeedbackSent: true})
          },
          cancelFeedback: () => {
            this.setState({...this.state, isFeedbackSent: false})
          },
          resetEmailContext: () => {
            this.setState({shallActivateEmailButton: false, isFeedbackSent: false})
          }
        }}>
        {this.props.children}
      </EmailContext.Provider>
    )
  }
}

export const EmailContext = React.createContext()


// WEBPACK FOOTER //
// ./src/context/EmailContext.js